module.exports = __webpack_public_path__ + "img/logo1.a826e620.png";